import { IApplicationState } from '../../../types/redux';

export const selectDevelopersData = (state: IApplicationState) => {
  return state.mainpage.developers;
};
